import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface DateInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  value?: string;
  onChange?: (value: string) => void;
}

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, value, onChange, ...props }, ref) => {
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let newValue = e.target.value;
      
      if (newValue) {
        const parts = newValue.split('-');
        if (parts[0] && parts[0].length > 4) {
          parts[0] = parts[0].slice(0, 4);
          newValue = parts.join('-');
        }
      }
      
      onChange?.(newValue);
    };

    const sanitizedValue = React.useMemo(() => {
      if (!value) return value;
      const parts = value.split('-');
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        return parts.join('-');
      }
      return value;
    }, [value]);

    return (
      <Input
        type="date"
        className={cn(className)}
        ref={ref}
        value={sanitizedValue || ""}
        onChange={handleChange}
        max="9999-12-31"
        {...props}
      />
    );
  }
);

DateInput.displayName = "DateInput";

export { DateInput };
